import {LeftOutlined} from '@ant-design/icons';
import {cn} from '@ds/helpers';

type ChortkeToolCardProps = {
  title: string;
  icon: React.ReactNode;
  iconTone: 'success' | 'primary';
  disabled?: boolean;
  onClick: () => void;
};

const ChortkeToolCard: React.FC<ChortkeToolCardProps> = ({
  title,
  icon,
  iconTone,
  disabled = false,
  onClick
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className="flex min-h-15.75 items-center justify-between rounded-[10px] border border-gray-02 bg-white p-3 pb-2.25 text-start disabled:cursor-not-allowed"
      onClick={onClick}
    >
      <span className="flex items-center gap-2">
        <span
          className={cn(
            'flex size-9.5 shrink-0 items-center justify-center rounded-full text-xl',
            iconTone === 'success'
              ? 'bg-green-coupon/10 text-green-coupon'
              : 'bg-orange-main/10 text-orange-main',
            disabled && 'bg-gray-02 text-gray-04'
          )}
        >
          {icon}
        </span>
        <span
          className={cn(
            'text-subtitle-sm text-gray-08',
            disabled && 'text-body-sm-emphasis text-gray-06'
          )}
        >
          {title}
        </span>
      </span>

      {disabled ? (
        <span className="flex h-5 w-10.5 items-center justify-center rounded-md border border-orange-light-09 bg-orange-main text-field-caption-emphasis text-white">
          به‌زودی
        </span>
      ) : (
        <span className="flex items-center gap-1 text-field-caption-emphasis text-gray-07">
          مشاهده
          <LeftOutlined aria-hidden />
        </span>
      )}
    </button>
  );
};

export default ChortkeToolCard;
